import LottieView from "lottie-react-native";
import { Text } from "react-native-paper";
import { View } from "react-native";

import { Button, Modal } from "../../../components";

export default function WaitlistModal({
  email,
  setWaitlistModalVisible,
  waitlistModalVisible,
}: {
  email: string;
  setWaitlistModalVisible: (value: boolean) => void;
  waitlistModalVisible: boolean;
}) {
  const onClose = () => setWaitlistModalVisible(false);
  return (
    <Modal {...{ visible: waitlistModalVisible, webStyle: { width: { sm: 640 } }, onDismiss: onClose }}>
      <View testID="success-modal" className="pt-12 items-center justify-between px-10 py-6 bg-sky-white">
        <View className="items-center">
          <View className="w-28 h-28">
            <LottieView style={{ flex: 1 }} autoPlay source={require("../../../../assets/lottie-icons/verified.json")} />
          </View>
          <Text className="text-title-3 font-700 text-ink-darkest mt-8">
            You will be notified if the event re-opens for registration.
          </Text>
          <Text className="text-regular-normal font-400 text-ink-dark mt-6 mb-4 px-4 text-center">
            You will receive an email at {email} if the event re-opens for registration. Respond to emails and notifications
            about event availability as quickly as possible, space will be limited. You are not guaranteed the opportunity to
            register.
          </Text>
        </View>

        <View className="w-full mt-8 mb-4">
          <Button mode="secondary" onPress={onClose}>
            Close
          </Button>
        </View>
      </View>
    </Modal>
  );
}
